import {MDCTextField} from '@material/textfield'
import {generate_recaptcha_token} from 'utils/form_utils'

new MDCTextField(el) for el in document.querySelectorAll('form#new_inquiry .mdc-text-field')

document.querySelector('form#new_inquiry').addEventListener 'submit', (e) ->
  e.preventDefault()
  generate_recaptcha_token -> document.querySelector('form#new_inquiry').submit()